import { render, staticRenderFns } from "./UserTipStat.vue?vue&type=template&id=0052650d&scoped=true&"
import script from "./UserTipStat.vue?vue&type=script&lang=js&"
export * from "./UserTipStat.vue?vue&type=script&lang=js&"
import style0 from "./UserTipStat.vue?vue&type=style&index=0&id=0052650d&lang=scss&scoped=true&"
import style1 from "./UserTipStat.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0052650d",
  null
  
)

export default component.exports